let patterns = {
    alphaDash: '\\S+.*',
    email: '^[a-z0-9._%+-]+@[a-z0-9.-]+\\.[a-z]{2,4}$',
    strongPassword: '(?=.*[a-z])(?=.*[A-Z])(?=.*[0-9])(?=.{8,})'
}

export { patterns };